<ul class="tile-menu">
  <li *ngFor="let item of items" class="tile-item gradient" [class.selected]="isSelected(item)" (click)="onClick(item)">
    <ng-container *ngTemplateOutlet="item.template"></ng-container>
  </li>
</ul>
<eve-validation-errors></eve-validation-errors>
